import React from "react";
import styled from "styled-components";
import { Button } from "../typography/button.component";

const PartnerWithUsDesc = styled.div`
  width: 50%;
  @media (max-width: 1025px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 74%;
  }
  @media (max-width: 480px) {
    width: 100%;
    max-width: 370px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 14px;
  }
`;
const PartnerWithUsLabel = styled.p`
  color: rgba(29, 109, 193, 1);
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;
  padding: 12px;
  background-color: rgba(29, 109, 193, 0.1);
  max-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
`;
const PartnerWithUsHeading = styled.h2`
  font-weight: 700;
  font-size: 30px;
  line-height: 100%;
  padding-top: 14px;
  color: rgba(29, 109, 193, 1);
  @media (max-width: 1025px) {
    width: 90%;
    font-size: 24px;
    text-align: center;
  }
`;
const PartnerWithUsPara = styled.p`
  font-size: 16px;
  line-height: 32px;
  padding-top: 24px;
  max-width: 70%;
    @media (max-width: 1025px) {
    font-size: 16px;
    text-align: center;
    max-width: 90%;
  }
  @media (max-width: 480px) {
    width: 90%;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
    max-width: 90%;
  }

`;
const PartnerWithUsPoints = styled.ul`
  font-size: 16px;
  line-height: 32px;
  max-width: 70%;
  @media (max-width: 480px) {
    width: 90%;
    line-height: 24px;
    
    font-size: 12px;
  }
`;
const PartnerWithUsButtons = styled.div`
  display: flex;
  padding-top: 32px;
  @media (max-width: 480px) {
    padding-top: 14px;
  }
`;

export const SectionDescriptionCardComponent = ({
  label,
  heading,
  para,
  buttons,
  button_primary,
  button_secondary,
  bullets,
  setModalOpen,
  option1GoTo,
  setIsPartnerWithUs,
}) => {
  return (
    <PartnerWithUsDesc>
      <PartnerWithUsLabel>{label}</PartnerWithUsLabel>
      <PartnerWithUsHeading>{heading}</PartnerWithUsHeading>
      <PartnerWithUsPara>{para.intro}</PartnerWithUsPara>
      {para.points && (
        <PartnerWithUsPoints>
          {para.points.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </PartnerWithUsPoints>
      )}
      <PartnerWithUsButtons>
        <Button
          onClick={
            option1GoTo == "modal"
              ? () => {
                  setIsPartnerWithUs && setIsPartnerWithUs(true);
                  setModalOpen(true);
                }
              : null
          }
          size={buttons == 1 ? "small" : "large"}
          variant="register"
        >
          {button_primary}
        </Button>
        &nbsp;&nbsp;
        {buttons > 1 ? (
          <Button variant="option2">{button_secondary}</Button>
        ) : null}
      </PartnerWithUsButtons>
    </PartnerWithUsDesc>
  );
};
